var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logo)?_c('sui-image',{attrs:{"src":_vm.logo,"size":"medium","centered":""}}):_vm._e(),_c("sui-header",{tag:"h3"},[_vm._v(" "+_vm._s(_vm.firmName)),_c('br'),_vm._v("Quarterly Attestation ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }